// extracted by mini-css-extract-plugin
export var boxItems = "_8f-1";
export var button = "_8f-5";
export var filterGroupBox = "_8f-0";
export var icon = "_8f-2";
export var iconSecondary = "_8f-4";
export var iconWrapper = "_8f-3";